import { render, staticRenderFns } from "./CIN.vue?vue&type=template&id=71c7be0c&"
import script from "./CIN.vue?vue&type=script&lang=js&"
export * from "./CIN.vue?vue&type=script&lang=js&"
import style0 from "./CIN.vue?vue&type=style&index=0&id=71c7be0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports